import { headerSchema } from "../configs";
import { useCreateHeaderMutation, useTypedSelector } from "../store";
import { showToast, ToastType } from "../utils/toast.utils";
import HeaderForm from "../forms/Header.form";
import { useNavigate } from "react-router-dom";

const CreateHeaderWrapper = () => {
  const restaurant = useTypedSelector((state) => state.session.restaurant);

  if (!restaurant)
    return (
      <div className="w-full flex justify-center mt-4 text-xl font-semibold">
        Veuillez sélectionner un restaurant
      </div>
    );

  return (
    <div className="w-full flex flex-col items-center justify-center">
      <CreateHeader restaurantId={restaurant._id} />
    </div>
  );
};

interface CreateheaderProps {
  restaurantId: string;
}

const CreateHeader: React.FC<CreateheaderProps> = ({ restaurantId }) => {
  const [CreateHeader, { isLoading }] = useCreateHeaderMutation();
  const navigate = useNavigate();

  const initialValues = {
    displayName: "",
    restaurant: restaurantId,
    description: "",
    displayOrder: 1,
  };

  return (
    <div className="p-4 w-full">
      <HeaderForm
        initialValues={initialValues}
        validationSchema={headerSchema}
        isLoading={isLoading}
        onSubmit={async (values, { resetForm }) => {
          const result = await CreateHeader(values);
          if (!result.error) {
            showToast("Catégorie créée", ToastType.SUCCESS);
            resetForm();
            navigate("/headers");
          }
        }}
      />
    </div>
  );
};

export default CreateHeaderWrapper;
